/**
 * Registers the wibblewabble theme with Backstage's new frontend system.
 * ThemeBlueprint is limited to the app plugin, so this is attached via a
 * frontend module for pluginId 'app' (see ./index.ts).
 */
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { wwUnifiedTheme } from './wwUnifiedTheme';

export const wwThemeExtension = ThemeBlueprint.make({
  name: 'wibblewabble',
  params: {
    theme: {
      id: 'wibblewabble',
      title: 'Wibblewabble',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={wwUnifiedTheme} children={children} />
      ),
    },
  },
});
